const VISITOR_CODE_KEY = 'visitorCode';

export const ensureVisitorCode = () => {
  const visitorCode = localStorage?.getItem(VISITOR_CODE_KEY);
  if (!visitorCode) {
    const randomCode = Math.random().toString(36).substr(2, 6);
    localStorage.setItem(VISITOR_CODE_KEY, randomCode);
  }
};
